import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ImageInterface } from 'src/app/types/image';

export interface HeroInterface {
  title: string;
  img: ImageInterface;
  description?: string;
  button_text?: string;
  button_hyperlink?: string;
}

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
})
export class HeroComponent {
  @Input() node: HeroInterface;

  constructor(private router: Router) {}

  buttonLink() {
    if (this.node?.button_hyperlink && this.node?.button_hyperlink.length > 0) {
      if (this.node?.button_hyperlink.indexOf('//') < 0) {
        this.router.navigate([this.node?.button_hyperlink]);
      } else if (typeof window !== 'undefined') {
        window?.open(this.node?.button_hyperlink, '_blank');
      }
    }
  }
}
